// PageLink — renders a PDF page anchor link.
//
// page: 0-indexed page_number from the backend (matches Mistral OCR index).
// PDF #page= anchors are 1-indexed, so we always add 1.
// When url is falsy, renders a plain <span> so the cell is never empty.

import "./Matching.css";

export default function PageLink({ url, page }) {
  const label = `p.${page + 1}`;
  if (!url) return <span>{label}</span>;
  return (
    <a
      href={`${url}#page=${page + 1}`}
      target="_blank"
      rel="noreferrer"
      className="mt-page-link"
    >
      {label}
    </a>
  );
}
